
import {Component, Prop, Vue} from "vue-property-decorator";
import {HarcTuruEntity} from "@/entity/HarcTuruEntity";
import {HarcDonemiEntity} from "@/entity/HarcDonemiEntity";
import {HarcTuru} from "@/enum/HarcTuru";
import {HarcHelper} from "@/helpers/HarcHelper";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";

@Component({
  components: {},
})
export default class HarcList extends Vue {
  @Prop({required: true}) takipId!: number;
  @Prop() hideCloseButton!: boolean | string;
  @Prop() items !: Array<AlacakKalemiEntity>;
  HarcTuru = HarcTuru

  harcDonemleri !: Array<HarcDonemiEntity>;

  get ilkMasrafToplami(): number {
    return HarcHelper.calculateIlkMasrafToplami(this.items || []);
  }



  get isHideClose() {
    return this.hideCloseButton || this.hideCloseButton === "";
  }

  search: string = "";
  headers = [
    {text: "Harç Türü", align: "start", sortable: false, value: "harc_turu",},
    {text: "Tarih", value: "tarih", sortable: false},
    {text: "Harç Oranı / Tutarı", value: "harc", sortable: false},
    {text: "Harç Tutarı", value: "harc_tutari", align: "right"},
  ];


  load() {
    this.$emit('load');
  }
}
